<template lang="pug">	
	.start-page.flex-col.max-limited.flex-col.space-medium.full-width.align-center
		.flex-row.space.wrap.align-center.center
			.tile.flex-col.space-large.align-center.center(@click="$emit('page', 'questions')")
				.flex-row.space.align-center
					.font-large
						fas(icon="wand-magic-sparkles", size="xs")
						span {{' '}}
						span {{$tCaption('Create an Ad')}}
				.hint {{$tCaption('Answer the questions carefully designed to help our specialists create an Ad for you.')}}
			.tile.flex-col.space-large.align-center.center(@click="$emit('page', 'templates')")
				.flex-row.space.align-center
					.font-large 
						fas(icon="magnifying-glass", size="xs")
						span {{' '}}
						span {{$tCaption('Select from templates')}}
				.hint {{$tCaption('Choose from a wide variety of templates.')}}
		.flex-col(v-if="info.branding && info.branding.About") {{info.branding.About}}
		.font-small.upper.grey.flex-col(v-if="info.branding && info.branding.Copyright")  © {{info.branding.Copyright}}
</template>

<script>
	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-start-page',
		props: ['info'],
		components: {
		},
		data() {
			return {
			};
		},
		mounted() {
		},
		methods: {

		}
	};
</script>
<style lang='scss'>
</style>
